import { useState } from "react";
import { Form, Row, Col } from "react-bootstrap";
import type { SalesExecutiveFormValues } from "../types";

export interface SalesExecutiveFormProps {
  id: string;
  initialValues: SalesExecutiveFormValues;
  isSubmitting: boolean;
  onSubmit: (values: SalesExecutiveFormValues) => void;
}

export const SalesExecutiveForm = ({
  id,
  initialValues,
  isSubmitting,
  onSubmit,
}: SalesExecutiveFormProps): JSX.Element => {
  const [values, setValues] = useState<SalesExecutiveFormValues>(initialValues);

  const set = <K extends keyof SalesExecutiveFormValues>(
    key: K,
    v: SalesExecutiveFormValues[K]
  ) => setValues((prev) => ({ ...prev, [key]: v }));

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (isSubmitting) return;
    onSubmit(values);
  };

  return (
    <Form id={id} data-testid={id} onSubmit={handleSubmit}>
      <Row>
        <Col sm={3}>
          <Form.Group className="mb-3">
            <Form.Label htmlFor="sales-executive-name">Name</Form.Label>
            <Form.Control
              id="sales-executive-name"
              type="text"
              required
              value={values.name}
              onChange={(e) => set("name", e.target.value)}
            />
          </Form.Group>
        </Col>
        <Col sm={3}>
          <Form.Group className="mb-3">
            <Form.Label htmlFor="sales-executive-title">Title</Form.Label>
            <Form.Control
              id="sales-executive-title"
              type="text"
              value={values.title}
              onChange={(e) => set("title", e.target.value)}
            />
          </Form.Group>
        </Col>
        <Col sm={3}>
          <Form.Group className="mb-3">
            <Form.Label htmlFor="sales-executive-phone">Phone</Form.Label>
            <Form.Control
              id="sales-executive-phone"
              type="text"
              value={values.phone}
              onChange={(e) => set("phone", e.target.value)}
            />
          </Form.Group>
        </Col>
        <Col sm={3}>
          <Form.Group className="mb-3">
            <Form.Label htmlFor="sales-executive-email">Email</Form.Label>
            <Form.Control
              id="sales-executive-email"
              type="email"
              value={values.email}
              onChange={(e) => set("email", e.target.value)}
            />
          </Form.Group>
        </Col>
      </Row>
    </Form>
  );
};

export default SalesExecutiveForm;
